import * as Sentry from "@sentry/react";
import { LogErrors } from "./LogErrors";
export const fetchHistoricalIncidentsForParticipant = async (participantId, token) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}Incident/FetchHistoricalIncidentsForParticipant?ParticipantId=${participantId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorMsg = `Error fetching historical incidents: ${response.status} - ${response.statusText}`;
      Sentry.captureMessage(errorMsg, "error");
      // LogErrors(user, logout, updateTokens, errorMsg);
      return null;
    }

    return await response.json();

  } catch (error) {
    // LogErrors(user, logout, updateTokens, "Error fetching incident history:", error);
    Sentry.captureException(error);
    return null;
  }
};